import { Action, Reducer } from 'redux';
import { AccessErrorActionTypes, AccessErrorState, AccessErrorTypes } from "./accessErrorTypes";

export const INITIAL_STATE: AccessErrorState = {
  hasAccessError: false
};

const AccessErrorReducer: Reducer<AccessErrorState> = (
  state: AccessErrorState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as AccessErrorActionTypes;
  switch (actionTypes.type) {
    case AccessErrorTypes.SET_ACCESS_ERROR:
      return {
        ...state,
        hasAccessError: actionTypes.payload.hasAccessError
      };
    case AccessErrorTypes.CLEAR_ACCESS_ERROR:
      return {
        ...state,
        hasAccessError: false
      };
    default:
      return state;
  }
};

export default AccessErrorReducer;